import { lazy, Suspense } from 'react'
import { Spinner, View } from 'tamagui'

const PdfModalContent = lazy(() => import('./pdfModalContent'))

interface Props {
    pdf?: string
    title: string
    onClose: () => void
    fileName: string
    hideDownloadButton?: boolean
    withAuth?: boolean
    isRawPdf?: boolean
}

const PdfModal = (props: Props) => (
    <Suspense
        fallback={
            <View display="flex" justifyContent="center" alignItems="center" height={200}>
                <Spinner size="large" />
            </View>
        }
    >
        <PdfModalContent {...props} />
    </Suspense>
)

export default PdfModal
